import {Injectable} from '@angular/core';
import {environment} from '../../../../src/environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CalendarHoliday} from './schedule.model';

@Injectable()
export class ScheduleApiService {


  constructor(private http: HttpClient) {
  }

  getCalendarHolidays(calendarId): Observable<CalendarHoliday[]> {
    return this.http.get<CalendarHoliday[]>(`/db/calendar/${calendarId}/calendarholiday`);
  }

  getObjectHolidays(objectId): Observable<CalendarHoliday[]> {
    return this.http.get<CalendarHoliday[]>(`/db/object/${objectId}/objectholiday`);
  }
  getScheduleTemplate(): Observable<any[]> {
    return this.http.get<any[]>(`/db/scheduletemplate`);
  }
}
